import { type XStyles } from './useXStyles'

export const mergeXStyles = <Keys extends string>(xStyles: XStyles<Keys>, customXStyles?: Partial<XStyles<Keys>>) => {
  if (!customXStyles) {
    return xStyles
  }

  const result: XStyles<Keys> = { ...xStyles }

  Object.keys(customXStyles).forEach((_key) => {
    const key = _key as Keys
    if (result[key]) {
      result[key] = [result[key], customXStyles[key]]
    }
    else {
      result[key] = customXStyles[key]
    }
  })

  return result
}
